<template>
  <IconButton
    :icon="shouldShowUserMenu ? Icon.CLOSE_V2 : Icon.HAMBURGER"
    class="h-md border-none dark:invert"
    @click="shouldShowUserMenu = !shouldShowUserMenu"
  />
  <Teleport v-if="shouldShowUserMenu" to="body">
    <div
      class="fixed bottom-0 left-0 right-0 top-0 z-10"
      :class="{
        'bg-lightPrimaryBackgroundColor/70 dark:bg-darkPrimaryBackgroundColor/70': shouldShowUserMenu,
      }"
      @click="shouldShowUserMenu = false"
    />
  </Teleport>
  <Teleport v-if="shouldShowUserMenu" to="#header">
    <div class="absolute right-0 ml-auto w-full">
      <div
        class="bg-lightPrimaryColor dark:bg-darkPrimaryColor ml-auto h-full w-full rounded-lg p-4 shadow-xl md:w-fit dark:shadow-xl"
      >
        <div class="gap-sm p-sm grid">
          <UserMenuButton
            :icon="Icon.HOME"
            :text="$t('message.home')"
            :to="{ name: 'home' }"
            @click="shouldShowUserMenu = !shouldShowUserMenu"
          />
          <DividerBar />
          <template v-if="userMandants && userMandants.length > 1 && userMandants.length < 5">
            <div
              v-for="(mandant, index) in userMandants"
              :key="index"
              class="hover:bg-primary/20 dark:hover:bg-primary/20 flex items-center justify-center rounded-lg p-2"
            >
              <router-link
                :to="{ name: 'mandantDashboard', params: { mandantId: mandant.id } }"
                class="h-full"
                @click="shouldShowUserMenu = !shouldShowUserMenu"
              >
                {{ mandant.id + " - " + mandant.name }}
              </router-link>
            </div>
            <DividerBar v-if="userMandants" />
          </template>
          <template v-if="currentMandant">
            <UserMenuButton
              :text="$t('message.notifications')"
              :to="{ name: 'notifications' }"
              @click="shouldShowUserMenu = !shouldShowUserMenu"
            >
              <template #icon>
                <NotificationTag />
              </template>
            </UserMenuButton>
            <DividerBar />
          </template>
          <UserMenuButton
            v-if="userId"
            :icon="Icon.GUEST"
            :text="$t('pages.profileSettings')"
            :to="{ name: 'userProfile' }"
            @click="shouldShowUserMenu = !shouldShowUserMenu"
          />
          <UserMenuButton
            :text="$t('message.news')"
            :to="{ name: 'releaseNotesPublic' }"
            @click="shouldShowUserMenu = !shouldShowUserMenu"
          >
            <template #icon>
              <BaseIcon class="invert-0 dark:invert" :icon="Icon.REFRESH" />
            </template>
          </UserMenuButton>
          <UserMenuButton
            v-if="userId"
            :icon="Icon.CUSTOMER_SERVICE"
            :text="$t('pages.support')"
            href="https://support.cloud.anex.is/servicedesk/customer/portal/5"
            @click="shouldShowUserMenu = !shouldShowUserMenu"
          />
          <UserMenuButton
            :icon="Icon.LOGOUT"
            :text="$t('message.logOut')"
            :to="{ name: 'logout' }"
            @click="shouldShowUserMenu = !shouldShowUserMenu"
          />
        </div>
      </div>
      <slot />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { Ref, ref, watch } from "vue";

import { storeToRefs } from "pinia";
import { Icon } from "../assets/icons/Icon";
import DividerBar from "../components/DividerBar.vue";
import IconButton from "../components/IconButton.vue";
import UserMenuButton from "../components/UserMenuButton.vue";
import { useUser } from "../composition-functions/user";
import { GetMandantsByIdsResponse, useMandant } from "../mandant/service.mandant";
import NotificationTag from "../notification/components/NotificationTag.vue";
import BaseIcon from "./BaseIcon.vue";

const mandantStore = useMandant();
const { currentMandant } = storeToRefs(mandantStore);
const { getMandantsByIds } = mandantStore;
const userStore = useUser();
const { mandantIds, userId } = storeToRefs(userStore);
const userMandants: Ref<null | GetMandantsByIdsResponse[]> = ref(null);
const shouldShowUserMenu: Ref<boolean> = ref(false);

watch(
  () => mandantIds,
  async () => {
    if (mandantIds.value.length === 0) {
      return;
    }
    const getMandantsByIdsResult = await getMandantsByIds({ mandantIds: mandantIds.value.slice(0, 5) });

    userMandants.value = getMandantsByIdsResult.items;
  },
  { immediate: true },
);
</script>
